import React from 'react';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import Divider from '@mui/material/Divider';
import IconButton from 'components/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  bindMenu,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';

const FileActions = ({ onRename, onMove, onDelete, onOpen }) => {
  const menuState = usePopupState({
    popupId: 'contextMenu',
    variant: 'popover',
  });
  return <>
    <IconButton icon={<MoreHorizOutlinedIcon />} {...bindTrigger(menuState)} size="large" />
    <Menu {...bindMenu(menuState)}>
      {onOpen && (
        <MenuItem
          onClick={() => {
            menuState.close();
            onOpen();
          }}
        >
          View
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          menuState.close();
          onRename();
        }}
      >
        Rename
      </MenuItem>
      <MenuItem
        onClick={() => {
          menuState.close();
          onMove();
        }}
      >
        Move to...
      </MenuItem>
      <Divider />
      <MenuItem
        onClick={() => {
          menuState.close();
          onDelete();
        }}
      >
        Delete
      </MenuItem>
    </Menu>
  </>;
};

export default FileActions;
